<mat-tab-group (selectedTabChange)="selectedTabValue($event)" #tabGroup>
  <mat-tab *ngFor="let stage of taskStagesList; let index = index" [label]="stage.stageName" class="tab-title">
    <ng-template mat-tab-label>
      <h4>
        {{ stage.stageName }}
        <span *ngIf="stage.taskStageUsersList != undefined">({{ stage.taskStageUsersList.length }})</span>
      </h4>
    </ng-template>
    <div>
      <div class="d-flex justify-content-between align-items-center my-4">
        <div class="d-flex gap-2 align-items-center stageClass reviewer_any">
          <div class="d-flex">
            <h4>{{ stage.anyOrAll | titlecase }}<span *ngIf="stage.noIfAny != null">-</span>{{ stage.noIfAny }}</h4>
            <span
              *ngIf="stage.isOverriden && (data.saveButtonForTraining || data.saveButtonForDocument || data.saveExtensionData || data.saveWithdrawData || data.saveDestructionData || data.saveButtonForForm || data.saveButtonForSetup)">
              <span>
                <img src="../../../assets/img/cr_module/Edit.svg" width="16px" height="16px" alt="edit"
                  (click)="editStageFunc(stage)" (keydown.enter)="editStageFunc(stage)" />
              </span>
            </span>
          </div>

        </div>
        <div class="action-buttons-container d-flex gap-2">
          <div
            *ngIf="!isReadOnly || data.saveButtonForTraining || data.saveButtonForexcution ||  data.saveButtonForDocument || data.saveExtensionData || data.saveWithdrawData || data.saveDestructionData || data.saveButtonForForm || data.saveButtonForSetup"
            class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            [matTooltip]="'Add'+ stage.stageName" (click)="addStageUserFunc(stage)"
            (keydown.enter)="addStageUserFunc(stage)">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add New</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Excel Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')">
            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">PDF Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
            (keydown.enter)="openAuditTrail('overAll',0)" matTooltip="Audit Trail">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Audit Trail</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            matTooltip="Refresh Grid">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text" (click)="refreshStageUsersGrid(stage)"
              (keydown.enter)="refreshStageUsersGrid(stage)">Reload</span>
          </div>
        </div>
      </div>
      <!-- <hr> -->
      <div class="table-container">
        <table class="dynamicReviewApprove-table-container">
          <th class="p-1" style="min-width:100px;">Level</th>
          <th class="p-1" style="min-width:100px;"></th>
          <th class="p-1" style="min-width:250px;">Users/Roles</th>
          <th class="p-1" style="min-width:300px;max-width:300px;">Status</th>
          <th class="p-1" style="min-width:200px;"></th>
          <th class="p-1">Actions</th>

          <tr *ngFor="
                let user of stage['taskStageUsersList']
                  | searchFilter : searchValue;
                let idx = index
              ">
            <td>
              <div
                *ngIf="idx==0? true : stage['taskStageUsersList'][idx].userLevel!=stage['taskStageUsersList'][idx-1].userLevel"
                class="label-container">
                <div class="addTaskStageCollabrative">Level&nbsp;:&nbsp;{{user.userLevel}}
                  <i class="fa-solid fa-pencil"
                    *ngIf="stage.isOverriden && (data.saveButtonForTraining || data.saveButtonForDocument || data.saveExtensionData || data.saveWithdrawData || data.saveDestructionData || data.saveButtonForForm || data.saveButtonForSetup)"
                    style="margin-left: 5px;" [matTooltip]="'Collaborative'" (click)="editCollaborativeFunc(user)"
                    (keydown.enter)="editCollaborativeFunc(user)"></i>
                </div>
                <div *ngIf="user.anyOrAll!=null">({{user.anyOrAll}}<span
                    *ngIf="user.noIfAny!=null">-{{user.noIfAny}}</span>)</div>
              </div>
            </td>
            <td style="min-width:100px;max-width:100px">
              <div *ngIf="user.userImage == null" class="userProfile-container">
                <img src="../../../assets/img/cr_module/user_profile.svg" width="45px" height="45px"
                  alt="User Profile" />
              </div>

              <div class="userProfile-container" *ngIf="user.userImage != null || user.userImage != undefined">
                <img class="userimg" src="data:image/*;base64,{{user.userImage}}" width="45px" height="45px"
                  alt="User Profile" />
              </div>
            </td>
            <td style="min-width:250px;max-width:250px;overflow-wrap: break-word;text-wrap: wrap;">
              <div class="label-container">
                User Name : <span>{{ user.userName }}</span>
              </div>
              <div class="label-container">
                User Role : <span>{{ user.userRole }}</span>
              </div>
            </td>
            <td>
              <div class="label-container">
                Requested On : <span>{{ user.requestedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss') :
                  userTimezone }}</span>
              </div>
              <div class="label-container">
                Completed On : <span>{{ user.completedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss') :
                  userTimezone }}</span>
              </div>
            </td>
            <td>
              <div *ngIf="user.status != null">
                <div class="commonStyle" [ngStyle]="{
                    'color': user.status.includes('Rejected') ? 'red' :
                             (user.status.includes('Approved') || user.status.includes('Reviewed')) ? 'green' :
                             user.status.includes('Requested More Info.') ? 'brown' :
                             'orange'
                  }">
                  Status :
                  <span>{{ user.status }}</span>
                </div>

              </div>

              <div class="label-container">
                Comments : <span>{{ user.comments }}</span>
              </div>
              <div class="label-container">
                Reason for Signature :
                <span>{{ user.reasonForSignature }}</span>
              </div>
            </td>
            <td>
              <div *ngIf="user.doc != undefined">
                <div class="download-button-continer btn-align" mat-dialog-actions>
                  <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                    (click)="downloadDocuments(user)">
                    <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download" />
                    <span class="ms-1">View</span>
                  </button>
                </div>
              </div>
              <div class="d-none">
                <label id="owner-validation" for="email" (click)="openswitchuser('owner', stage, user)"
                  (keydown.enter)="openswitchuser('owner', stage, user)"><a><img title="Switch User"
                      src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                      height="25" /></a></label>
                <i class="fa-solid fa-pencil" style="margin-left: 5px" [matTooltip]="'Edit ' + stage.stageName"
                  (click)="editStageUserFunc(stage, user)" (keydown.enter)="editStageUserFunc(stage, user)"></i>

                <i class="fa-sharp fa-solid fa-trash" style="margin-left: 5px"
                  [matTooltip]="'Delete ' + stage.stageName" (click)="deleteStageUserFunc(stage, user)"
                  (keydown.enter)="deleteStageUserFunc(stage, user)"></i>

              </div>
              <div class="dropdown actions_dropdown">

                <i *ngIf="data.saveButtonForTraining || data.saveButtonForDocument || data.saveExtensionData || data.saveWithdrawData || data.saveDestructionData || data.saveButtonForForm || data.saveButtonForSetup"
                  matTooltip="Edit" (click)="editStageUserFunc(stage, user)"
                  (keydown.enter)="editStageUserFunc(stage, user)" style="margin-left: 8px;">
                  <a><img src="../../../assets/img/cr_module/Edit.svg" alt="edit" width="18px" height="18px" /></a>
                </i>
                <i matTooltip="Delete"
                  *ngIf="data.saveButtonForTraining || data.saveButtonForDocument || data.saveExtensionData || data.saveWithdrawData || data.saveDestructionData || data.saveButtonForForm || data.saveButtonForSetup"
                  (click)="deleteStageUserFunc(stage, user)" (keydown.enter)="deleteStageUserFunc(stage, user)"
                  style="margin-left: 5px;"><a><img src="../../../assets/img/cr_module/delete.svg" width="18px"
                      height="18px" alt="delete" /></a></i>
                <i *ngIf="message.showSwitchUser " [matTooltip]="'Switch User'"
                  (click)="openswitchuser('owner', stage, user)" (keydown.enter)="openswitchuser('owner', stage, user)"
                  style="margin-left: 5px;">
                  <a><img src="../../../assets/img/cr_module/userSwitch.svg" alt="Switch User" width="18px"
                      height="18px" /></a></i>
                <i matTooltip="Audit Trail" *ngIf="message.isAuditTrailUser" style="margin-left: 5px;"
                  (click)="openAuditTrail('individual',user)" (keydown.enter)="openAuditTrail('individual',user)"><i
                    class="fa-solid fa-clipboard" style="font-size: 18px;color: #005C8A;"></i></i>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #addOrEditStageUserPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditStageUserFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row" *ngIf="message.isShowApplicableForAllCheckBox">
        <mat-checkbox [(ngModel)]="IsApplicableRevApp" [checked]="IsApplicableRevApp">Applicable To All
          Documents</mat-checkbox>
      </div>
      <div class="row" [hidden]="stageData.stageName !='Signoff'">
        <div class="col-md-3"><label for="level">Level</label></div>
        <div class="col-md-9" [hidden]="isShowLevelSingle">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedLevelValue" (closed)="levelSearchText=''"
            (click)="focusSearch('focus-level1-search')" (keydown.enter)="focusSearch('focus-level1-search')"
            id="level1">
            <input type="search" id="focus-level1-search" class="dropdownsearchstyle" [(ngModel)]="levelSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of levelDropdown | assessmentSearch : levelSearchText" [value]="item.valueExp">
              {{ item.displayExp}}
            </mat-option>
          </mat-select>
        </div>
        <span id="level1-required-msg" style="margin-top: 3%;margin-left: 25%;">Please select level</span>
        <div class="col-md-9" *ngIf="isShowLevelSingle">
          <input type="text" class="input-filed-continers" [(ngModel)]="selectedLevelValue"
            style="height:80% !important;" disabled>
        </div>
      </div>
      <br *ngIf="!isShowLevelSingle && stageData.stageName =='Signoff'">
      <div class="row">
        <div class="col-md-3"><label for="userRole">User Role</label></div>
        <div class="col-md-9" [hidden]="isShowUserRoleSingle">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedUserRoleValue" (closed)="userRoleSearchText=''"
            (click)="focusSearch('focus-userRole-search')" (keydown.enter)="focusSearch('focus-userRole-search')"
            id="userRole">
            <input type="search" id="focus-userRole-search" class="dropdownsearchstyle" [(ngModel)]="userRoleSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of userRoleDropdown | assessmentSearch : userRoleSearchText"
              [value]="item.valueExp" (onSelectionChange)="onUserRoleSelect($event,item)">
              {{ item.displayExp}}
            </mat-option>
          </mat-select>
        </div>
        <span id="userRole-required-msg" style="margin-top: 3%;margin-left: 25%;">Please select user role</span>
        <div class="col-md-9" *ngIf="isShowUserRoleSingle">
          <input type="text" class="input-filed-continers" [(ngModel)]="selectedUserRoleValue"
            style="height:80% !important;" disabled>
        </div>
      </div>
      <br *ngIf="!isShowUserRoleSingle">
      <div class="row" [hidden]="!visibleEditButton">
        <div class="col-md-3"><label for="user ">User</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedUserValue" (closed)="userSearchText=''"
            (click)="focusSearch('focus-user-search')" (keydown.enter)="focusSearch('focus-user-search')" id="user1">
            <input type="search" id="focus-user-search" class="dropdownsearchstyle" [(ngModel)]="userSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of userDropdown | assessmentSearch : userSearchText" [value]="item.valueExp">
              {{ item.displayExp}}
            </mat-option>
          </mat-select>

        </div>
        <span id="user1-required-msg" style="margin-top: 3%;margin-left: 25%;">Please select user</span>
      </div>
      <br *ngIf="visibleEditButton">
      <div class="row" [hidden]="!visibleAddButton">
        <div class="col-md-3"><label for="user ">User</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9">
          <mat-select matInput multiple placeholder="Select" #userFeild
            [ngStyle]="selectedUser ? {'cursor' : 'pointer'} : {'cursor' : 'not-allowed'}" [(ngModel)]="selectedUser"
            id="user" (closed)="userSearchText=''" (click)="focusSearch('focus-b-area-search')"
            (keydown.enter)="focusSearch('focus-b-area-search')">
            <input type="search" id="focus-b-area-search" class="dropdownsearchstyle" [(ngModel)]="userSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isAllUsersSelected" (change)="toggleAllSelection('userFeild')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of userDropdown| multiAssessmentSearchPipe :userSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onUsersSelect($event,item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>

        </div>
        <span id="user-required-msg" style="margin-top: 3%;margin-left: 25%;">Please select user</span>
      </div>
      <br *ngIf="visibleAddButton">
      <div class="row" [hidden]="stageData.stageName =='Signoff'">
        <div class="col-md-3"><label for="level">Level</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9" *ngIf="!isShowLevelSingle">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedLevelValue" (closed)="levelSearchText=''"
            (click)="focusSearch('focus-level-search')" (keydown.enter)="focusSearch('focus-level-search')" id="level">
            <input type="search" id="focus-level-search" class="dropdownsearchstyle" [(ngModel)]="levelSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of levelDropdown | assessmentSearch : levelSearchText" [value]="item.valueExp">
              {{ item.displayExp}}
            </mat-option>
          </mat-select>
        </div>
        <span id="level-required-msg" style="margin-top: 3%;margin-left: 25%;">Please select level</span>
        <div class="col-md-9" *ngIf="isShowLevelSingle">
          <input type="text" class="input-filed-continers" [(ngModel)]="selectedLevelValue"
            style="height:80% !important;" disabled>
        </div>
      </div>
      <br *ngIf="!isShowLevelSingle && stageData.stageName !='Signoff'">

    </div>
  </div>
  <br>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditStageUserFunction(stageUserData,'MAIN')"
      *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton" (click)="addAndEditStageUserFunction(stageUserData,'MAIN')"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditStageUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #editStagePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{stageData.stageName}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row" style="margin-bottom:2%;">
        <div class="col-md-3"><label for="anyOrAll ">Any or All</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAnyOrAll" (closed)="anyOrAllTxt=''"
            (click)="focusmethod('anyOrAllSearch')" (keydown.enter)="focusmethod('anyOrAllSearch')">
            <input type="search" id="anyOrAllSearch" class="dropdownsearchstyle" [(ngModel)]="anyOrAllTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onAnyOrAllRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of anyOrAllDropdown| assessmentSearch :anyOrAllTxt"
              (onSelectionChange)="onAnyOrAllSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <br>
      <div class="row" *ngIf="selectedAnyOrAllValue !='ALL'">
        <div class="col-md-3"><label for="noIfAny">No. If Any</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedNoIfAny" (closed)="noIfAnyTxt=''"
            (click)="focusmethod('noIfAnySearch')" (keydown.enter)="focusmethod('noIfAnySearch')">
            <input type="search" id="noIfAnySearch" class="dropdownsearchstyle" [(ngModel)]="noIfAnyTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onNoIfAnyRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of noIfAnyDropdown| assessmentSearch :noIfAnyTxt"
              (onSelectionChange)="onNoIfAnySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(stageData)">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deleteStageUserPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label for="deleteReason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteReason" rows="6" class="textarea-filed-continers" type="text"
            [(ngModel)]="stageUserData.deleteReason"></textarea>
          <span id="deleteReason-required-msg">Please enter reason for delete</span>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editCollaborativePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditCollaborativeFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Level-{{stageData.userLevel}}&nbsp;Collaborative</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row" style="margin-bottom:2%;">
        <div class="col-md-3"><label for="anyOrAll ">Any or All</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAnyOrAll" (closed)="anyOrAllTxt=''"
            (click)="focusmethod('focus-any-or-all')" (keydown.enter)="focusmethod('focus-any-or-all')">
            <input type="search" id="focus-any-or-all" class="dropdownsearchstyle" [(ngModel)]="anyOrAllTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onAnyOrAllRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of anyOrAllDropdown| assessmentSearch :anyOrAllTxt"
              (onSelectionChange)="onAnyOrAllSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row" *ngIf="selectedAnyOrAllValue !='ALL'" style="margin-bottom:2%;margin-top: 6%;">
        <div class="col-md-3"><label for="noIfAny">No. If Any</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedNoIfAny" (closed)="noIfAnyTxt=''"
            (click)="focusmethod('focus-no-if-any')" (keydown.enter)="focusmethod('focus-no-if-any')">
            <input type="search" id="focus-no-if-any" class="dropdownsearchstyle" [(ngModel)]="noIfAnyTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onNoIfAnyRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of noIfAnyDropdown| assessmentSearch :noIfAnyTxt"
              (onSelectionChange)="onNoIfAnySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditCollaborativeFunction(stageData)">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditCollaborativeFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="docViewer?.doc"></app-document-viewer>